import { render } from "./MergePatients.vue?vue&type=template&id=35a31ffb"
import script from "./MergePatients.vue?vue&type=script&lang=js"
export * from "./MergePatients.vue?vue&type=script&lang=js"

import "./MergePatients.vue?vue&type=style&index=0&id=35a31ffb&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__